module.exports = __webpack_public_path__ + "static/antd-table-inline-edit-hover-02567e69833483150fae29cd64af42c2.png";